import React, { useEffect, useState } from 'react';
import FlyMateShell from './FlyMateShell';
import PublicFlyMateShell from './PublicFlyMateShell';

type FlyMateMode = 'loading' | 'public' | 'legacy';

const FlyMateModeShell: React.FC = () => {
  const [mode, setMode] = useState<FlyMateMode>('loading');

  useEffect(() => {
    const controller = new AbortController();
    fetch('/api/flymate/config', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: controller.signal,
    })
      .then(async (response) => {
        if (!response.ok) throw new Error('FlyMate configuration is unavailable.');
        const config = await response.json();
        setMode(config?.runtime?.enabled === false ? 'legacy' : 'public');
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') setMode('public');
      });
    return () => controller.abort();
  }, []);

  if (mode === 'legacy') return <FlyMateShell />;
  if (mode === 'public') return <PublicFlyMateShell />;
  return (
    <section className="grid h-[100svh] min-h-[620px] place-items-center border-y border-white/10 bg-[#050b18] text-white" aria-label="Loading FlyMate">
      <div className="flex items-center gap-3 text-sm text-slate-400">
        <span className="h-2 w-2 animate-pulse rounded-full bg-cyan-300" />
        Preparing FlyMate…
      </div>
    </section>
  );
};

export default FlyMateModeShell;
